import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhiteDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1322_6458",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 19,
		height: 16,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .708984,
			width: 17.44,
			height: 16,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1322_6458)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.79883 9.77656H1.69883V9.87656V12.7812C1.69883 13.1375 1.84593 13.4477 2.12976 13.7081C2.41353 13.9684 2.74749 14.1 3.12727 14.1H14.6404C15.0202 14.1 15.3541 13.9684 15.6379 13.7081C15.9217 13.4477 16.0688 13.1375 16.0688 12.7812V9.87656V9.77656H15.9688H14.6404H14.5404V9.87656V12.6812H3.22727V9.87656V9.77656H3.12727H1.79883ZM8.81623 10.9659L8.88383 11.0279L8.95143 10.9659L13.2246 7.04556L13.3049 6.97187L13.2246 6.89819L12.2725 6.02475L12.2049 5.96273L12.1373 6.02475L9.64805 8.30849V1V0.9H9.54805H8.21961H8.11961V1V8.30849L5.63034 6.02475L5.56273 5.96273L5.49513 6.02475L4.54308 6.89819L4.46277 6.97187L4.54308 7.04556L8.81623 10.9659Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .2
		})
	})]
});
export default SvgWhiteDownload;
